<template lang="pug">
BaseSelect.w-32(v-if="languages.length > 1", :modelValue="locale", class="md:w-38", @change="onSelectLocale")
  template(#current)
    .flex.items-center.gap-1
      BaseFlagIcon.rounded-full.overflow-hidden.text-base(type="square", :country="getCountry(locale)")
      span.truncate.text-xs {{ $t(`locales.${locale}`) }}
  BaseOption.h-8(v-for="language in languages", :key="language", :label="language", :value="language", :data="language")
    .flex.items-center.gap-1
      BaseFlagIcon.rounded-full.overflow-hidden.text-base(type="square", :country="getCountry(language)")
      span.truncate.text-xs {{ $t(`locales.${language}`) }}
</template>

<script setup>
import { useLocale } from '@/composables/core/useLocale'

const { $SoundControl } = useNuxtApp()

// 使用 useLocale composable 來管理語言切換
const { locale, supportedLocales, changeLocale } = useLocale()

// 使用 @nuxtjs/i18n 配置的語言列表
const languages = supportedLocales

const onSelectLocale = async (lang) => {
  $SoundControl.sound.play('click')
  try {
    await changeLocale(lang)
  } catch (error) {
    console.error('[langSwitcher] Failed to change locale:', error)
  }
}

const getCountry = (locale) => {
  return locale.split('-')[1].toLowerCase()
}
</script>

<style lang="scss"></style>
